module.exports = __webpack_public_path__ + "img/icon-trends2.8f6a52c7.svg";